import { ApiService, type ApiRequestConfig } from "./api.service";
import type { TProjectMembership } from "@/types/project";

export interface TAddProjectMembersData {
  members: { member_id: string; role: string }[];
}

export class ProjectMemberService extends ApiService {
  /**
   * The project's members. `q` narrows them by name or email on the server; a
   * blank one is no filter, the same request as none.
   */
  async listMembers(
    slug: string,
    projectId: string,
    { q }: { q?: string } = {},
    config?: ApiRequestConfig,
  ): Promise<TProjectMembership[]> {
    const query = q?.trim();
    return this.get(`/api/workspaces/${slug}/projects/${projectId}/members/`, {
      ...config,
      ...(query ? { params: { q: query } } : {}),
    });
  }

  async addMembers(
    slug: string,
    projectId: string,
    data: TAddProjectMembersData,
  ): Promise<TProjectMembership[]> {
    return this.post(`/api/workspaces/${slug}/projects/${projectId}/members/`, data);
  }

  async updateMember(
    slug: string,
    projectId: string,
    memberId: string,
    data: { role: string },
  ): Promise<TProjectMembership> {
    return this.patch(`/api/workspaces/${slug}/projects/${projectId}/members/${memberId}/`, data);
  }

  async removeMember(slug: string, projectId: string, memberId: string): Promise<void> {
    return this.delete(`/api/workspaces/${slug}/projects/${projectId}/members/${memberId}/`);
  }

  async memberMe(
    slug: string,
    projectId: string,
    config?: ApiRequestConfig,
  ): Promise<TProjectMembership> {
    return this.get(`/api/workspaces/${slug}/projects/${projectId}/project-members/me/`, config);
  }
}
